module.exports = __webpack_public_path__ + "img/daikin-logo.4e3f5e32.png";